"use client";

import { shouldRedirectToWeb } from "@/utils/should-redirect";
import Link from "next/link";
import { useEffect, useState } from "react";

export default function NotFound() {
	const [shouldRedirect, setShouldRedirect] = useState(false);

	useEffect(() => {
		// Get the current path & search to preserve it in the redirect
		const { pathname, search } = window.location;

		// Check if this path should redirect to web.settlin.in
		const needsRedirect = process.env.NODE_ENV === "production" && shouldRedirectToWeb(pathname);
		setShouldRedirect(needsRedirect);

		// Redirect to web.settlin.in if needed
		if (needsRedirect) {
			window.location.href = `https://web.settlin.in${pathname}${search}`;
		}
	}, []);

	// Show redirecting message only if actually redirecting
	if (shouldRedirect) {
		return (
			<div className="flex min-h-screen items-center justify-center">
				<div className="text-center">
					<h1 className="text-2xl font-bold mb-4">Redirecting...</h1>
					<p className="text-gray-600">Taking you to the link...</p>
				</div>
			</div>
		);
	}

	// Show 404 page for routes that don't need redirection
	return (
		<div className="flex min-h-screen items-center justify-center bg-background">
			<div className="text-center px-4">
				<h1 className="text-6xl font-bold text-primary mb-4">404</h1>
				<h2 className="text-2xl font-semibold mb-2">Page Not Found</h2>
				<p className="text-muted-foreground mb-8">The page you are looking for does not exist.</p>
				<Link
					href="/"
					className="inline-block px-6 py-3 bg-primary text-primary-foreground rounded-lg hover:bg-primary/90 transition-colors"
				>
					Go to Homepage
				</Link>
			</div>
		</div>
	);
}
